export const BASE_URL = 'https://udigo-image.s3.ap-northeast-2.amazonaws.com'

export const BANNER_IMAGE = 'banner'

export const GUIDE_IMAGES = ['guide01', 'guide02', 'guide03', 'guide04']

export const SAMPLE_IMAGES = [
  '63building',
  'beach',
  'blue-house',
  'gym',
  'kids-cafe',
  'lotte-tower',
  'park',
  'pc-bang',
  'playground',
  'sebit-island',
  'shopping-mall',
  'ski-resort',
]
